(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dales-cart-help"] && !Shopify.designMode) return;
  try {
    function placeCartHelp(){
 const help=document.getElementById('dm-cart-help');
 const checkout=document.querySelector('.cart-template .btn-actions');
 if(help && checkout){(document.querySelector(".dm-cart-agreement") || checkout).insertAdjacentElement("afterend",help);}
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',placeCartHelp,{once:true});}else{placeCartHelp();}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dales-desktop-navigation"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',function(event){document.querySelectorAll('.dm-category-menu[open]').forEach(function(menu){if(!menu.contains(event.target))menu.open=false;});});
document.addEventListener('keydown',function(event){if(event.key==='Escape'){document.querySelectorAll('.dm-category-menu[open]').forEach(function(menu){menu.open=false;menu.querySelector('summary').focus();});}});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dales-mobile-brands"] && !Shopify.designMode) return;
  try {
    (function(){
 function setup(){
  document.querySelectorAll('[data-dm-brand-row]').forEach(function(row){
   if(row.dataset.dmBrandsReady)return;
   row.dataset.dmBrandsReady='true';
   var track=row.querySelector('[data-dm-brand-track]'),prev=row.querySelector('[data-dm-brand-prev]'),next=row.querySelector('[data-dm-brand-next]'),hint=row.querySelector('[data-dm-brand-hint]');
   function sync(){
    var overflow=track.scrollWidth>track.clientWidth+2;
    prev.hidden=!overflow;next.hidden=!overflow;hint.hidden=!overflow;row.classList.toggle('dm-brands-fit',!overflow);
    prev.disabled=track.scrollLeft<=2;next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2;
   }
   function move(direction){
    track.scrollBy({left:direction*Math.max(120,track.clientWidth*0.8),behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
   }
   prev.addEventListener('click',function(){move(-1);});
   next.addEventListener('click',function(){move(1);});
   track.addEventListener('scroll',sync,{passive:true});
   new ResizeObserver(sync).observe(track);
   sync();
  });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup);else setup();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dales-navigation-polish"] && !Shopify.designMode) return;
  try {
    (function(){
 function setup(){
  var root=document.getElementById('site-nav-mobile'),labels=document.getElementById('dm-navigation-labels');
  if(!root || !labels)return;
  var text=JSON.parse(labels.textContent),launchers=document.querySelectorAll('[data-mobile-menu-toggle="menu"]'),lastLauncher=null;
  document.querySelectorAll('.site-nav-vertical-text').forEach(function(element){
   var label=element.querySelector('.text');if(label)label.textContent=text.part_categories;
   element.setAttribute('role','button');element.setAttribute('tabindex','0');element.setAttribute('aria-label',text.part_categories);
   function expanded(){element.setAttribute('aria-expanded',String(element.parentElement.classList.contains('is-open') || element.parentElement.classList.contains('is-open-2')));}
   new MutationObserver(expanded).observe(element.parentElement,{attributes:true,attributeFilter:['class']});
   element.addEventListener('keydown',function(event){if(event.key==='Enter' || event.key===' '){event.preventDefault();element.click();}});
   expanded();
  });
  function button(element,label){
   element.setAttribute('role','button');element.setAttribute('tabindex','0');element.setAttribute('aria-label',label);
   element.removeAttribute('aria-describedby');
   element.addEventListener('keydown',function(event){if(event.key==='Enter' || event.key===' '){event.preventDefault();event.stopPropagation();element.click();}});
  }
  function sync(){
   var open=document.body.classList.contains('open_menu');
   launchers.forEach(function(element){element.setAttribute('aria-expanded',String(open));element.setAttribute('aria-label',open?text.close:text.menu);});
   root.querySelectorAll('[data-toggle-menu-mb]').forEach(function(element){element.setAttribute('aria-expanded',String(element.closest('li').classList.contains('is-open')));});
  }
  launchers.forEach(function(element){button(element,text.menu);element.setAttribute('aria-controls',root.id);element.addEventListener('click',function(){lastLauncher=element;});});
  root.querySelectorAll('a[aria-label="link"]').forEach(function(element){if(element.textContent.trim())element.removeAttribute('aria-label');});
  root.querySelectorAll('[data-toggle-menu-mb]').forEach(function(element){
   var link=element.parentElement.querySelector('a'),panel=element.parentElement.nextElementSibling;
   button(element,text.categories.replace('[category]',link?link.textContent.trim():''));
   element.addEventListener('click',function(event){event.preventDefault();event.stopPropagation();element.parentElement.click();});
   if(panel){panel.id=panel.id || 'dm-nav-panel-'+Array.prototype.indexOf.call(root.querySelectorAll('[data-toggle-menu-mb]'),element);element.setAttribute('aria-controls',panel.id);}
  });
  root.querySelectorAll('.menu-mb-title').forEach(function(element){button(element,text.back);});
  var close=root.querySelector('.close_menu .close');if(close)button(close,text.close);
  document.addEventListener('keydown',function(event){
   if(event.key==='Escape' && document.body.classList.contains('open_menu')){
    var launcher=lastLauncher || Array.from(launchers).find(function(element){return element.getClientRects().length;});
    if(launcher){event.preventDefault();launcher.click();launcher.focus();}
   }
  });
  new MutationObserver(sync).observe(document.body,{attributes:true,attributeFilter:['class']});
  new MutationObserver(sync).observe(root,{subtree:true,attributes:true,attributeFilter:['class']});
  sync();
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup);else setup();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dales-product-check"] && !Shopify.designMode) return;
  try {
    function placeProductCheck(){
  const help=document.getElementById('dm-product-check');
  const form=document.querySelector('.product_template .product_form_wrapper');
  if(help && form){form.insertAdjacentElement('beforebegin',help);help.hidden=false;}
  const comparison=document.getElementById('dm-price-comparison');
  if(comparison && help && form){help.insertAdjacentElement('beforebegin',comparison);comparison.hidden=false;}
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',placeProductCheck,{once:true});}else{placeProductCheck();}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dales-vehicle-parts"] && !Shopify.designMode) return;
  try {
    (() => {
  function init() {
    const bar = document.getElementById('dm-vehicle-parts');
    if (!bar) return;
    const category = bar.querySelector('#dm-part-category');
    const subcategory = bar.querySelector('#dm-part-subcategory');
    const brand = bar.querySelector('#dm-part-brand');
    const emptyHelp = document.getElementById('dm-empty-help');
    const allowed = new Set(['performance-air-intake-systems','brake-upgrades-canada','cooling-system-upgrades','performance-drivetrain-upgrades-canada','engine-upgrades-canada','exhaust-system-upgrades-canada','turbo-upgrades','fuel-system-upgrades','performance-suspension-upgrades-canada','tuning-programmers','wheel-upgrades-spacers-canada'].map(h => '/collections/' + h));
    let groups = [], signature = '', queued = false;
    function queryParts() {
      const params = new URLSearchParams(location.search);
      const facet = params.get('Facet');
      const query = facet !== null ? facet : (Array.from(params.keys()).find(part => part.includes('/')) || '');
      return query.split('/');
    }
    function filters() {
      const raw = queryParts();
      const result = [];
      for (let i = 0; i + 1 < raw.length; i += 2) {
        if (['Year','Make','Model','Submodel'].includes(raw[i])) result.push(raw[i], raw[i + 1]);
      }
      return result;
    }
    function navigate(path, vendor, preserveBrand = false) {
      const pieces = filters();
      if (preserveBrand) {
        const raw = queryParts();
        const index = raw.indexOf('vendor');
        if (index >= 0 && raw[index + 1]) {
          try { vendor = decodeURIComponent(raw[index + 1]); } catch (_) { vendor = ''; }
        }
      }
      if (vendor) pieces.unshift('vendor', encodeURIComponent(vendor));
      location.assign(path + (pieces.length ? '?' + pieces.join('/') : ''));
    }
    function options(select, entries, selected) {
      select.replaceChildren(...entries.map(([value, label]) => {
        const option = document.createElement('option');
        option.value = value; option.textContent = label; return option;
      }));
      select.value = selected;
    }

    function updateEmptyHelp(widget) {
      const root = widget.closest('#cm-collection-page, #cm_results');
      const nothing = root?.querySelector('.cmTemplate_nothing');
      const empty = !!nothing && /no results found/i.test(nothing.textContent);
      emptyHelp.hidden = !empty;
      if (!empty) return;
      if (bar.nextElementSibling !== emptyHelp) bar.insertAdjacentElement('afterend', emptyHelp);
      nothing.classList.add('dm-empty-replaced');
      const raw = queryParts();
      const vehicle = filters();
      const label = vehicle.filter((_,i) => i % 2).map(value => {
        try { return decodeURIComponent(value).replace(/-/g,' '); } catch (_) { return value; }
      }).join(' ');
      const vehicleLine = emptyHelp.querySelector('[data-dm-empty-vehicle]');
      vehicleLine.hidden = !label;
      const vehicleText = vehicleLine.querySelector('span');
      if (vehicleText.textContent !== label) vehicleText.textContent = label;
      const brandLink = emptyHelp.querySelector('[data-dm-empty-brands]');
      const filterLink = emptyHelp.querySelector('[data-dm-empty-filters]');
      const withoutBrand = [];
      for (let i=0;i+1<raw.length;i+=2) {
        if(raw[i]!=='vendor') withoutBrand.push(raw[i],raw[i+1]);
      }
      brandLink.hidden = !raw.includes('vendor');
      brandLink.href = location.pathname + (withoutBrand.length ? '?' + withoutBrand.join('/') : '');
      filterLink.hidden = raw.every((value,i) => i%2 || ['vendor','Year','Make','Model','Submodel'].includes(value)) || raw.length<2;
      filterLink.href = location.pathname + (vehicle.length ? '?' + vehicle.join('/') : '');
    }

    function update() {
      queued = false;
      const widget = document.querySelector('#cm-collection-page .cm_vehicle-widget, #cm_results .cm_vehicle-widget');
      if (!widget) { bar.hidden = true; emptyHelp.hidden = true; return; }
      if (widget.nextElementSibling !== bar) widget.insertAdjacentElement('afterend', bar);
      bar.hidden = false;
      updateEmptyHelp(widget);
      const seen = new Set();
      groups = Array.from(document.querySelectorAll('.menu-lv-1')).map(li => {
        const a = li.querySelector(':scope > p > a');
        if (!a || !allowed.has(a.getAttribute('href')) || seen.has(a.getAttribute('href'))) return null;
        const path = a.getAttribute('href'); seen.add(path);
        const links = new Map();
        li.querySelectorAll('.site-nav-dropdown a[href^="/collections/"]').forEach(link => {
          const href = link.getAttribute('href');
          if (href !== path) links.set(href, link.textContent.trim());
        });
        return {path, title:a.textContent.trim(), links:Array.from(links)};
      }).filter(Boolean);
      const current = groups.find(g => g.path === location.pathname || g.links.some(([path]) => path === location.pathname));
      const brands = [...new Set(Array.from(document.querySelectorAll('.cm_field-vendor .facetentrykey')).map(a => a.textContent.trim()).filter(Boolean))].sort((a,b) => a.localeCompare(b));
      const raw = queryParts();
      const vendorIndex = raw.indexOf('vendor');
      let selectedBrand = '';
      if (vendorIndex >= 0) { try { selectedBrand = decodeURIComponent(raw[vendorIndex + 1] || ''); } catch (_) {} }
      if (selectedBrand && !brands.includes(selectedBrand)) brands.push(selectedBrand);
      const vehicle = filters();
      document.querySelectorAll('.dm-parts-categories nav a[href], .dm-parts-wide-links a[href], .dm-parts-feature-link[href], [data-dm-original-description] .opts a[href]').forEach(link => {
        const url = new URL(link.getAttribute('href'), location.href);
        if (url.origin === location.origin && url.pathname.startsWith('/collections/')) {
          const existing = url.search.slice(1).split('/');
          const vendorAt = existing.indexOf('vendor');
          const pieces = vendorAt >= 0 && existing[vendorAt + 1] ? ['vendor',existing[vendorAt + 1],...vehicle] : selectedBrand ? ['vendor',encodeURIComponent(selectedBrand),...vehicle] : vehicle;
          const href = url.pathname + (pieces.length ? '?' + pieces.join('/') : '') + url.hash;
          if (link.getAttribute('href') !== href) link.setAttribute('href', href);
        }
      });
      const vehicleText = vehicle.filter((_,i) => i % 2).map(value => {
        try { return decodeURIComponent(value).replace(/-/g,' '); } catch (_) { return value; }
      }).join(' ');
      const partTitle = document.querySelector('.dm-parts-copy h1')?.textContent.trim() || document.title;
      document.querySelectorAll('.dm-parts-fitment[href^="mailto:"]').forEach(link => {
        const address = link.getAttribute('href').split('?')[0];
        const subject = 'Fitment question: ' + (vehicleText || partTitle);
        const body = ['Hello Dale’s,','', 'Please help me confirm fitment.', 'Vehicle: ' + (vehicleText || 'Please enter year, make, model and trim'), 'Parts: ' + partTitle, 'Page: ' + location.origin + location.pathname + location.search, '', 'My question: '].join('\n');
        const href = address + '?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
        if (link.getAttribute('href') !== href) link.setAttribute('href', href);
      });
      const next = JSON.stringify([groups, current?.path, location.pathname, brands, selectedBrand]);
      if (signature === next) return;
      signature = next;
      options(category, [['',bar.dataset.choose], ...groups.map(g => [g.path,g.title])], current?.path || '');
      options(subcategory, current ? [[current.path,bar.dataset.all + ' ' + current.title],...current.links] : [['',bar.dataset.choose]], current ? location.pathname : '');
      subcategory.disabled = !current;
      options(brand, [['',bar.dataset.brands], ...brands.map(b => [b,b])], selectedBrand);
      brand.disabled = !brands.length;
    }
    emptyHelp.querySelector('[data-dm-empty-category]').addEventListener('click', () => {
      category.scrollIntoView({block:'center',behavior:'smooth'});
      category.focus({preventScroll:true});
    });
    category.addEventListener('change', () => { if (category.value) navigate(category.value, undefined, true); });
    subcategory.addEventListener('change', () => { if (subcategory.value) navigate(subcategory.value, undefined, true); });
    brand.addEventListener('change', () => navigate(location.pathname, brand.value));
    const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(update); } };
    new MutationObserver(schedule).observe(document.body, {childList:true,subtree:true});
    window.addEventListener('popstate', schedule);
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();
  } catch(e) { console.error(e); }
})();

})();
